import { type FC } from 'react';

import { TRAINERS_ITEMS } from '@entities/catalog';
import { CatalogSection } from '@widgets/catalog-section';

const TrainersPage: FC = () => (
  <CatalogSection title="Тренажёры" basePath="/catalog/trainers" items={TRAINERS_ITEMS} />
);

export default TrainersPage;
